import React from 'react';
import { FlexColumn, FlexRow } from 'styles/Layout';
import styled from 'styled-components';
import { media } from 'styles/Mixins';

const Container = styled(FlexRow)`
  position: relative;
  background-color: ${({ invertedStyle }) =>
    invertedStyle ? '#F4F4F4' : '#fff'};
  flex-direction: ${({ invertedStyle }) =>
    invertedStyle ? 'row-reverse' : 'row'};
  min-width: 162px;
  padding: ${({ invertedStyle }) =>
    invertedStyle ? '18px 10px 18px 25px' : '18px 30px 18px 10px'};
  ${media.sm`
    background-color: #fff;
    padding: 6px;
    flex-direction: column;
  `};
`;

const ImageContainer = styled(FlexColumn)`
  height: 112px;
  width: 50%;
  justify-content: center;
  align-items: center;
  ${media.sm`
    margin-bottom: 12px;
    width: 100%;
  `};
`;

const Image = styled.img`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
`;

const TextContainer = styled(FlexColumn)`
  width: 50%;
  height: auto;
  align-items: ${({ invertedStyle }) =>
    invertedStyle ? 'flex-start' : 'center'};
  justify-content: center;
  ${media.sm`
    align-items: center;
    width: 100%;
    height: 48px;
  `};
`;

const Text = styled.span`
  font-size: 14px;
  line-height: 17px;
  color: #5a5a5a;
  text-align: left;
  max-width: 163px;
  width: ${({ width }) => width};
  ${media.sm`
    text-align: center;
    max-width: ${({ width }) => width};
  `};
`;

type PropsType = {
  text: string,
  imageSrc: string,
  imageWidth: string,
  imageHeight: string,
  textWidth: string,
  index: number
};

export default function BenefitItemComponent(props: PropsType) {
  const { text, imageSrc, imageWidth, imageHeight, textWidth, index } = props;

  const hasInveretedStyle = () => {
    if ((index + 1) % 2 !== 0) return false;
    return true;
  };

  return (
    <Container invertedStyle={hasInveretedStyle()}>
      <ImageContainer>
        <Image src={imageSrc} width={imageWidth} height={imageHeight} />
      </ImageContainer>
      <TextContainer invertedStyle={hasInveretedStyle()}>
        <Text width={textWidth}>{text}</Text>
      </TextContainer>
    </Container>
  );
}
